export default __webpack_public_path__ + "static/media/hbs-cbb-banner-1.99a67b7f.jpg";